/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
/**
 * Field Registry
 * Maps form_attribute_type_id to field component and metadata.
 * Single source of truth — no more hardcoded IDs scattered in code.
 */

const FIELD_REGISTRY = {
    1:  { key: 'smalltext',   component: 'TextField',       inputType: 'text' },
    2:  { key: 'hidden',      component: 'HiddenField',     inputType: 'hidden' },
    3:  { key: 'textarea',    component: 'TextareaField',   inputType: 'textarea' },
    4:  { key: 'markdown',    component: 'RichTextField',   inputType: 'markdown' },
    5:  { key: 'number',      component: 'TextField',       inputType: 'number' },
    6:  { key: 'location',    component: 'LocationField',   inputType: null },
    7:  { key: 'date',        component: 'DateField',       inputType: 'date' },
    8:  { key: 'datetime',    component: 'DateField',       inputType: 'datetime-local' },
    9:  { key: 'select',      component: 'SelectField',     inputType: null },
    10: { key: 'radio',       component: 'RadioField',      inputType: null },
    11: { key: 'checkbox',    component: 'CheckboxField',   inputType: null },
    12: { key: 'fileupload',  component: 'FileUploadField', inputType: null },
    13: { key: 'category',    component: 'CategoryField',   inputType: null },
    14: { key: 'gdpr',        component: 'GdprField',       inputType: null },
    15: { key: 'query',       component: 'TextField',       inputType: 'text' },
    16: { key: 'email',       component: 'TextField',       inputType: 'email' },
    17: { key: 'rating',      component: 'RatingField',     inputType: null },
    18: { key: 'audio',       component: 'AudioField',      inputType: null },
    19: { key: 'geolocation-automatic', component: 'GeolocationAutomaticField', inputType: null }
}

export function getFieldEntry(typeId) {
    return FIELD_REGISTRY[typeId] || null
}

export function getFieldComponent(typeId) {
    const entry = FIELD_REGISTRY[typeId]
    return entry ? entry.component : null
}

export function getFieldInputType(typeId) {
    const entry = FIELD_REGISTRY[typeId]
    return entry ? entry.inputType : null
}

export default FIELD_REGISTRY
